'use client';

import { zodResolver } from '@hookform/resolvers/zod';
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { useForm } from 'react-hook-form';

import {
  registerForm,
  registerFormInput,
} from '@/app/[locale]/(new)/(public)/projects/[slug]/_page.css';
import {
  HeroFormData,
  heroFormSchema,
} from '@/app/_components/form-email-to-register/types';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from '@/app/_components/ui/form';
import { Input } from '@/app/_components/ui/input';
import { CallToAction } from '@/app/_componentsv2/call-to-action';
import analyticsManager from '@/lib/analytics';

import redirectToAuthFromEmail from './actions';

export function RegisterForm() {
  const t = useTranslations();
  const pathname = usePathname();

  const onSubmit = (values: HeroFormData) => {
    analyticsManager.client.sendEvent({
      event: 'email_collect',
    });
    redirectToAuthFromEmail(values, pathname);
  };

  const form = useForm({
    resolver: zodResolver(heroFormSchema(t)),
    defaultValues: {
      email: '',
    },
  });

  return (
    <Form {...form}>
      <form className={registerForm} onSubmit={form.handleSubmit(onSubmit)}>
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Input
                  className={registerFormInput}
                  placeholder={t('auth.email')}
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <CallToAction type="submit" label="C'est parti" />
      </form>
    </Form>
  );
}
